import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home/Home";
import ScrollTop from "./components/ScrollTop";
import Blogs from "./pages/Blogs/Blogs";
import BlogDetails from "./pages/BlogDetails/[id]";
import Contact from "./pages/Contact/Contact";
import OurStory from "./pages/OurStory/OurStory";
import Offerings from "./pages/Offerings/Offerings";
import CMSSolutions from "./pages/Offerings/CMSSolutions/CMSSolutions";
import UIUX from "./pages/Offerings/UIUX/UIUX";
import SoftwareTesting from "./pages/Offerings/SoftwareTesting/SoftwareTesting";
import ITSupportManaged from "./pages/Offerings/ITSupportManaged/ITSupportManaged";
import SoftwareProductDevelopment from "./pages/Offerings/SoftwareProductDevelopment/SoftwareProductDevelopment";
import PythonBackendDevelopment from "./pages/Offerings/PythonBackendDevelopment/PythonBackendDevelopment";
import AIAutomation from "./pages/Offerings/AIAutomation/AIAutomation";
import DatabaseDataSolutions from "./pages/Offerings/DatabaseDataSolutions/DatabaseDataSolutions";
import DigitalMarketingSEO from "./pages/Offerings/DigitalMarketingSEO/DigitalMarketingSEO";
import IndustryDetail from "./pages/Industries/IndustryDetail/IndustryDetail";
import FinTech from "./pages/Industries/FinTech/FinTech";
import FoodCatering from "./pages/Industries/FoodCatering/FoodCatering";
import Education from "./pages/Industries/Education/Education";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";
import NotFound from "./pages/NotFound/NotFound"; // Create a 404 component

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/ourStory" element={<OurStory />} />
        <Route path="/offerings" element={<Offerings />} />
        <Route path="/productDevelopment" element={<Navigate to="/offerings" replace />} />
        <Route path="/CMSSolutions" element={<CMSSolutions />} />
        <Route path="/UIUX" element={<UIUX />} />
        <Route path="/SoftwareTesting" element={<SoftwareTesting />} />
        <Route path="/ITSupportManaged" element={<ITSupportManaged />} />
        <Route path="/software-product-development" element={<SoftwareProductDevelopment />} />
        <Route path="/web-application-development" element={<Navigate to="/software-product-development" replace />} />
        <Route path="/mobile-app-development" element={<Navigate to="/software-product-development" replace />} />
        <Route path="/python-backend-development" element={<PythonBackendDevelopment />} />
        <Route path="/ai-automation" element={<AIAutomation />} />
        <Route path="/database-data-solutions" element={<DatabaseDataSolutions />} />
        <Route path="/digital-marketing-seo" element={<DigitalMarketingSEO />} />
        <Route path="/industries/fintech" element={<FinTech />} />
        <Route path="/industries/food-catering" element={<FoodCatering />} />
        <Route path="/industries/agriculture" element={<IndustryDetail slug="agriculture" />} />
        <Route path="/industries/education" element={<Education />} />
        <Route path="/industries/healthcare" element={<IndustryDetail slug="healthcare" />} />
        <Route path="/industries/real-estate" element={<IndustryDetail slug="real-estate" />} />
        <Route path="/industries/retail-ecommerce" element={<IndustryDetail slug="retail-ecommerce" />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogDetails/:id" element={<BlogDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

        {/* 404 Catch-All Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
